import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import _ from 'lodash';

import Api from 'util/Api';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange({target}) {
        this.setState({
            [target.name]: target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({isSubmitting: true});

        Api.resetPassword({username: this.state.username})
            .then((data) => {
                this.setState({
                    hasSubmitted: true,
                    isSubmitting: false
                });
            }, (err) => {
                if (err.code === 'auth/user-not-found') {
                    this.setState({
                        hasSubmitted: true,
                        isSubmitting: false
                    });
                } else {
                    this.setState({
                        errorMessage: err.message,
                        isSubmitting: false,
                    });
                }
            });
    }

    render() {
        const hasUsername = _.get(this.state, 'username.length') > 0;
        const submitButtonEnabled = hasUsername && !this.state.isSubmitting;

        return (
            <div className='forgot-password-form row justify-content-md-center'>
                <div className='col col-md-6'>
                    {!this.state.hasSubmitted ? (
                        <div>
                            <h3>Forgot Password?</h3>
                            <p className='text-muted'>Enter your email below and we will send you password reset instructions.</p>

                            {this.state.errorMessage &&
                                <div className="alert alert-danger" role="alert">{this.state.errorMessage}</div>
                            }

                            <form onSubmit={this.handleSubmit}>
                                <div className='form-group'>
                                    <input className='form-control' type='email' name='username' placeholder='Enter Email' onChange={this.handleChange} />
                                </div>

                                <button className='btn btn-primary' type='submit' disabled={!submitButtonEnabled}>Submit</button>
                            </form>

                            <small className="form-text">
                                <Link className='ml-1' to='/login'>Back to Login</Link>
                            </small>
                        </div>
                    ) : (
                        <div>
                            <p>
                                An email has been sent with a link to reset your password. If you do not receive an email, please contact your system administrator.
                            </p>
                        </div>

                    )}
                </div>
            </div>
        );
    }
}

export default ForgotPassword;
